import { conditions } from "helpers";
import { ConditionName, ICommentPopoverProps } from "interfaces";
import { useAppSelector } from "redux-share/hooks";
import Popover from "../popover/popover";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const CommentContentPopover = dynamic(() => import("./commentContentPopover"));

const CommentsPopover = ({ status, onClose, setScrollEnd }: ICommentPopoverProps) => {
    const { params } = useAppSelector(({ videoData: { params, isComplexPortrait } }) => ({ params, isComplexPortrait }), shallowEqual);

    return (
        <Popover
            status={status}
            onClose={onClose}
            styles={{ width: "100%" }}
            isFullHeight={conditions(ConditionName.isComplexPortrait)}
            isHeader={conditions(ConditionName.isComplexPortrait)}
            headerTitle={conditions(ConditionName.isComplexPortrait) ? "دیدگاه ها" : ""}
            type={conditions(ConditionName.isComplexPortrait) ? "popover" : "modal"}
            isHasCatchUpLineOnTop={conditions(ConditionName.isComplexPortrait)}
            classNames={`${conditions(ConditionName.isComplexPortrait) && params.theme === "light" ? "!pl-bg-white" : "!pl-bg-black/[0.7]"}`}
        >
            {status ? <CommentContentPopover setScrollEnd={setScrollEnd} /> : <></>}
        </Popover>
    );
};

export default CommentsPopover;
